import { useEffect, useState } from "react";
import api from "../../../../services/api";
import HeaderSession from "../../../../utils/headerSession";
import FerramentaNavegacaoExportacao from "../../../../utils/paginacao";
import ListaSolicitacao from "../licenciamento/listaSolicitacao";
import RegisterAccess from "../../../../utils/registerAccess";
import { SolicitacoesLicenciamentoExcel } from "../../../exports/gerarelatorioexcel";
import { SolicitacaoLicenciamentoPdf } from "../../../exports/gerarelatoriopdf";
import TabelaLoading from "../../../../load/tabelaLoading";


export default function SolicitacoesRenovacao() {
  //  const navigate = useNavigate()
  // const user = useSelector(state => state.account.user);
  const [tipo, setTipo] = useState('')
  const [estabelecimentos, setEstabelecimentos] = useState('')
  const [page, setPage] = useState(1)
  const [perPage, setPerPage] = useState(50)
  const [order, setOrder] = useState('')
  const [loading, setLoading] = useState(false);
  const [configLista, setConfigLista] = useState('');
  const [provincia, setProvincia] = useState('');
  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");

  useEffect(() => {

    setLoading(true)
    setEstabelecimentos('')
    api.get(`/estabelecimentos?page=${page}&status=Análise&tipoEntrada=Renovação&perPage=${perPage}&tipoId=${tipo}&dataInicio=${dataInicio}&dataFim=${dataFim}&provincia=${provincia}&sortBy=nome:${order}`)
      .then(response => {
        // console.log(response)
        setConfigLista(response.data);
        setEstabelecimentos((prevItems) => [...prevItems, ...response.data.estabelecimentos]);

        setLoading(false)
      }).catch(err => { setLoading(false) })

  }, [page, perPage, order, tipo, provincia, dataInicio, dataFim]);


  return (
    <>
      <RegisterAccess page={'lista de solicitacoes de renovacao'} />

      <HeaderSession
        title='LISTA DE SOLICITAÇÕES DE RENOVAÇÃO'
        actions={true}
        handleExportExcel={() => SolicitacoesLicenciamentoExcel(estabelecimentos)}
        handleExportPDF={() => SolicitacaoLicenciamentoPdf(estabelecimentos)}
      />

      {/* <SearshEstabelecimento setEstabelecimentos={setEstabelecimentos} functionFilter={setTipo} placeholder={'Filtra por nome, número de entrada, data'} /> */}

      {estabelecimentos &&

        <ListaSolicitacao
          estabelecimentos={estabelecimentos}
          setEstabelecimentos={setEstabelecimentos}
          tipo={tipo}
          setTipo={setTipo}
          provincia={provincia}
          setProvincia={setProvincia}
          setDataInicio={setDataInicio}
          setDataFim={setDataFim}
          dataInicio={dataInicio}
          dataFim={dataFim}
        >
          <FerramentaNavegacaoExportacao
            configLista={configLista}
            lista={estabelecimentos}
            page={page}
            setPage={setPage}
            setPerPage={setPerPage}
            setOrder={setOrder}
          />
        </ListaSolicitacao>
      }

      {loading && <TabelaLoading />}
    </>
  )
}
